import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { CARD_TYPES } from '../../../shared/constants';

import mq from '../../../styles/breakpoints';
import colors from '../../../styles/colors';
import { Body, H2 } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import defaultImage from '../../../images/quote-block-default-image.svg';

import { QuoteItemProps } from './QuoteItem.types';

const imageStyle = { width: '100%', height: '100%', borderRadius: '50%' };

const QuoteItem = ({ title, subtitle, children, image }: QuoteItemProps) => (
  <Container id={CARD_TYPES.quote}>
    <InnerWrapper>
      <Quote>
        <H2>{children}</H2>
      </Quote>
      <ImgTextWrapper>
        {image && (
          <ImageContainer>
            {image?.gatsbyImageData ? (
              <GatsbyImage
                data-testid="gatsby-image"
                alt=""
                style={imageStyle}
                imgStyle={imageStyle}
                image={image.gatsbyImageData as IGatsbyImageData}
              />
            ) : (
              <DefaultImage
                data-testid="default-image"
                src={image?.file?.url || defaultImage}
                alt=""
              />
            )}
          </ImageContainer>
        )}
        <PersonDescription data-testid="person-description">
          <NameLG>
            {title} - {subtitle}
          </NameLG>
          <NameSM>
            <span>{title} </span>
            <span>{subtitle}</span>
          </NameSM>
        </PersonDescription>
      </ImgTextWrapper>
    </InnerWrapper>
  </Container>
);

export default QuoteItem;

const Container = styled.section`
  width: 100%;
`;

const InnerWrapper = styled.div`
  width: 100%;

  ${mq.from.breakpoint.L`
    max-width: 840px;
    margin: 0 auto;
  `}
`;

const NameLG = styled.span`
  display: none;

  ${mq.from.breakpoint.L`
    display: block;`}
`;

const NameSM = styled.span`
  display: flex;
  flex-direction: column;

  ${mq.from.breakpoint.L`
    display: none;`}
`;

const ImgTextWrapper = styled.div`
  align-items: center;
  display: flex;

  ${mq.from.breakpoint.L`
    margin-top: 0;
    align-self: flex-end;
  `}
`;

const PersonDescription = styled(Body)`
  color: ${colors.abnMutedGreen400};
  font-weight: 500;
`;

const Quote = styled.div`
  box-sizing: border-box;
  position: relative;
`;

const ImageContainer = styled.div`
  height: 64px;
  margin-right: ${Spacings.M};
  min-height: 64px;
  min-width: 64px;
  width: 64px;

  ${mq.from.breakpoint.L`
    width: 72px;
    height: 72px;
    min-width: 72px;
    min-height: 72px;
  `}
`;

const DefaultImage = styled.img`
  width: 100%;
`;
